import { aiContextRegistry } from '../AIContextRegistry';

aiContextRegistry.register({
  id: 'actif',
  label: 'Données actif',
  description: "Historique 30j et position d'un actif par symbole",
  icon: '📈',
  tokens: ['$actif', '$stock', '$titre'],
  parameterized: true,
  parameterSeparator: ':',
  examples: [
    { text: '@Claude analyse technique $actif:PAAS' },
    { text: '@Grok compare $actif:PAAS et $actif:AG' },
  ],
});
